import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const PestControl = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my pest control business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps pest control businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for pest control businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most pest control businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my pest control business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like pest control. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Pest Control - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Pest Control CRM", url: "/industries/pest-control" }
  ];

  const industryData = {
    name: 'Pest Control',
    title: 'Capture Emergency Pest Calls & Build Recurring Treatment Plans',
    subtitle: 'Never miss an urgent pest call, automate treatment reminders, and convert emergencies into long-term maintenance contracts',
    icon: '🐜',
    challenges: [
      'Missing emergency calls means lost revenue',
      'Hard to follow up on seasonal treatments',
      'Clients forget about quarterly maintenance',
      'Time wasted giving quotes over the phone',
      'Difficult to track treatment schedules'
    ],
    solutions: [
      '24/7 emergency call capture with instant response',
      'Automated seasonal treatment reminders',
      'Recurring treatment plan automation',
      'Instant online quotes based on square footage',
      'Treatment schedule tracking and alerts'
    ],
    features: [
      'Emergency call routing 24/7',
      'Automated treatment reminders',
      'Recurring maintenance plan automation',
      'Online instant quote calculator',
      'Treatment history tracking',
      'Before/after documentation',
      'Review automation',
      'Service area mapping'
    ],
    results: [
      '85% of emergency calls convert to recurring',
      'Never miss an after-hours call',
      '3x more recurring contracts',
      '5.8K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Pest Control UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for pest control businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for pest control UK, pest control business software, pest control customer management, pest control lead generation UK"
        url="/industries/pest-control"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default PestControl;